// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.img {
    height: 200px;
    width: auto;
}

.img img{
    height: 100%;
}


::ng-deep app-image-upload {
    display: block;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFkZC1jYXRlZ29yeS5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0ksYUFBYTtJQUNiLFdBQVc7QUFDZjs7QUFFQTtJQUNJLFlBQVk7QUFDaEI7OztBQUdBO0lBQ0ksY0FBYztBQUNsQiIsImZpbGUiOiJhZGQtY2F0ZWdvcnkuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5pbWcge1xuICAgIGhlaWdodDogMjAwcHg7XG4gICAgd2lkdGg6IGF1dG87XG59XG5cbi5pbWcgaW1ne1xuICAgIGhlaWdodDogMTAwJTtcbn1cblxuXG46Om5nLWRlZXAgYXBwLWltYWdlLXVwbG9hZCB7XG4gICAgZGlzcGxheTogYmxvY2s7XG59Il19 */`, "",{"version":3,"sources":["webpack://./src/app/pages/category-management/add-category/add-category.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;;AAGA;IACI,cAAc;AAClB;AACA,wgBAAwgB","sourcesContent":[".img {\n    height: 200px;\n    width: auto;\n}\n\n.img img{\n    height: 100%;\n}\n\n\n::ng-deep app-image-upload {\n    display: block;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
